module.exports = __webpack_public_path__ + "img/part3-4.87737436.png";